import {Component} from '@angular/core';


@Component({
    selector: 'app-repository-policy-change-aside',
    templateUrl: './repository-policy-change-aside.component.html',
})

export class RepositoryPolicyChangeAsideComponent {
}
